'use strict'
import React, { useState, useEffect, useRef, useCallback } from 'react'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'
import { AgGridReact } from 'ag-grid-react'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'
import { Toolbar } from 'primereact/toolbar'
import { Button } from 'primereact/button'
import { Toast } from 'primereact/toast'
import { TableLineDisable } from '../../../components/TableLineDisable/TableLineDisable'
import { validRule, RULES } from '../../../constants/Entitlements'
import { api, request } from '../../../util/handlerRequestUtil'
import { getMessage } from '../../../util/IntlMessages'
import './style.css'

function ListActionTypesJSON() {
  const [data, setData] = useState([])
  const [gridApi, setGridApi] = useState(null)
  const gridRef = useRef()
  const toast = useRef(null)

  useEffect(() => {
    loadData()
  }, [])

  async function loadData() {
    const items = await request(api.listCustomFieldsJSON())
    setData(items)
  }

  const updateData = async (id, reportGroup, isJsonText, fieldName) => {
    try {
      await request(api.updateCustomFieldJSON(id, reportGroup, isJsonText))
      toast.current.show({
        severity: 'info',
        summary: `${fieldName} atualizado com sucesso.`,
        life: 3000
      })
      loadData()
    } catch (error) {
      toast.current.show({
        severity: 'danger',
        summary: `Não foi possivel atualizar ${fieldName}.`,
        life: 3000
      })
    }
  }

  function getColumns() {
    const columns = [
      {
        headerName: getMessage('actionTypeId'),
        field: 'name',
        filter: 'agTextColumnFilter',
        cellRenderer: ({ value, data }) => <TableLineDisable item={value} line={data} />
      },
      {
        headerName: getMessage('customFieldFormName'),
        field: 'fieldName',
        filter: 'agTextColumnFilter',
        width: 600,
        cellRenderer: ({ value, data }) => <TableLineDisable item={value} line={data} />
      },
      {
        headerName: 'Incluir no JSON',
        field: 'isJsonText',
        filter: 'agTextColumnFilter',
        editable: true,
        cellEditor: 'agSelectCellEditor',
        cellEditorParams: {
          values: ['Sim', 'Não']
        },
        width: 150,
        cellRenderer: ({ value, data }) => <TableLineDisable item={value} line={data} />
      },
      {
        headerName: 'Grupo do JSON Report',
        field: 'reportGroup',
        filter: 'agNumberColumnFilter',
        editable: true,
        width: 250,
        cellRenderer: ({ value, data }) => <TableLineDisable item={value} line={data} />
      }
    ]

    const hasAccess = validRule(RULES.ACTION_TYPE_JSON) // Remove o lapis da lista
    if (hasAccess === true) {
      return columns
    }

    if (columns !== null) {
      columns.pop()
      return columns
    }
  }

  const defaultColDef = {
    sortable: true,
    resizable: true,
    minWidth: 150,
    enableRowGroup: false,
    enablePivot: false,
    enableValue: true,
    floatingFilter: true
  }

  const onGridReady = (params) => {
    setGridApi(params.api)
    params.api.sizeColumnsToFit()
  }

  const onFilterTextBoxChanged = useCallback(() => {
    gridRef.current.api.setQuickFilter(document.getElementById('filter-text-box').value)
  }, [])

  function renderHeader() {
    const leftContents = (
      <React.Fragment>
        <h2>
          <b>Lista JSON Report</b>
        </h2>
      </React.Fragment>
    )

    const rightContents = (
      <React.Fragment>
        <div style={{ display: 'flex', marginRight: 8 }}>
          <IconField iconPosition="left">
            <InputIcon className="pi pi-search"> </InputIcon>
            <InputText
              type="text"
              style={{ width: '100%' }}
              id="filter-text-box"
              placeholder="Pesquisar"
              onInput={onFilterTextBoxChanged}
            />
          </IconField>
        </div>
        <Button icon="pi pi-file-excel" className="p-button-success mr-2" onClick={() => gridApi.exportDataAsCsv()} />
      </React.Fragment>
    )

    return <Toolbar start={leftContents} end={rightContents} />
  }

  const onCellEditingStopped = useCallback(({ data }) => {
    updateData(data.id, data.reportGroup == '' ? null : data.reportGroup, data.isJsonText, data.fieldName)
  }, [])

  return (
    <>
      {renderHeader()}
      <div style={{ width: '100%', height: '70vh' }}>
        <div
          style={{
            height: '100%',
            width: '100%'
          }}
          className="ag-theme-alpine"
        >
          <Toast ref={toast} />
          <AgGridReact
            columnDefs={getColumns()}
            defaultColDef={defaultColDef}
            rowData={data}
            onGridReady={onGridReady}
            rowSelection={'single'}
            rowGroupPanelShow={'always'}
            pivotPanelShow={'always'}
            ref={gridRef}
            cacheQuickFilter={true}
            serverSideInfiniteScrolling={true}
            cacheBlockSize={50}
            maxBlocksInCache={2}
            onCellEditingStopped={onCellEditingStopped}
          />
        </div>
      </div>
    </>
  )
}

export default ListActionTypesJSON
